/* Home page sections in page order. Eyebrow numbers come from the position here, so
   reordering this list (to match HomePage.jsx) renumbers every section at once. */
export const SECTIONS = [
  { key: "services", label: "What we do" },
  { key: "process", label: "How we work" },
  { key: "work", label: "Case studies" },
  { key: "testimonials", label: "Testimonials" },
  { key: "team", label: "Team" },
  { key: "faq", label: "FAQs" },
  { key: "contact", label: "Contact" },
];

export function sectionEyebrow(key) {
  const index = SECTIONS.findIndex((s) => s.key === key);
  if (index === -1) throw new Error(`Unknown section "${key}"`);
  return { number: String(index + 1).padStart(2, "0"), label: SECTIONS[index].label };
}
